<template>
  <div class="label-container">
    <label aria-hidden="true" class="v-label v-label--active" style="">{{ label }}</label>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.label-container {
  position: relative;
  padding-top: 12px;
  margin-top: 4px;
}
.v-label {
  position: absolute;
  left: 5px;
  top: 6px;
  right: auto;
  transform: translateY(-10px) scale(0.75);
  overflow: hidden;
  text-overflow: ellipsis;
  transform-origin: top left;
  white-space: nowrap;
  pointer-events: none;

  font-size: 16px;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
